module.exports = "#pmViewHolder{\n    width:1500px;\n    height:800px;\n    \n    margin:30px auto;\n    \n    padding:20px;\n}"